import { Avatar, Box, Grid2, Pagination, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material"
import MUIButton from "../../reusable_components/components/MUIButton";
import Dropdown from "../../reusable_components/components/Dropdown";
import { useContext, useEffect, useState } from "react";
import { useClientReferalDropDownQuery, useGetReferalTableListMutation } from "../../redux/clientReferences/clientReferences.api";
import './clientReferences.css'
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import SearchIconLg from "../../assets/Icons/SearchIcon";

const ClientReferences = () => {

    const navigate = useNavigate()
    const { Profile } = useSelector((state) => state.common)
    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalDataCount, setTotalDataCount] = useState(0)
    const [selectedStatus, setSelectedStatus] = useState("")
    const [clientRefTableDatas, setClientRefTableDatas] = useState([])
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [searchKeyword, setSearchKeyword] = useState("")

    const { Snackbar } = useContext(SnackbarContext)

    const handlePageChange = (e, newPage) => {
        setPage(newPage)
    }

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10))
        setPage(0)
    }

    const [referalList] = useGetReferalTableListMutation()
    const { data: clientReferalDropDown } = useClientReferalDropDownQuery()

    const handleSearchKeywordChange = (e) => {
        const value = e.target.value
        setSearchKeyword(value)
    }

    const handleStatusChange = (value) => {
        setSelectedStatus(value)
    }

    useEffect(() => {
        const getTableDatas = async () => {
            try {
                const type = selectedStatus?.toLowerCase() === 'all' ? "" : selectedStatus

                const payload = {
                    page: (page - 1),
                    size: rowsPerPage,
                    type: type
                }

                const response = await referalList(payload).unwrap()
                setShowTableLoader(false)
                if (response?.status === 200) {
                    setClientRefTableDatas(response?.response?.data || [])
                    setTotalDataCount(response?.response?.count)
                }
            } catch (err) {
                Snackbar('Network error', 'error')
                setShowTableLoader(false)
            }
        }
        setShowTableLoader(true)
        getTableDatas()
    }, [referalList, page, rowsPerPage, selectedStatus])

    const handleAddClientRefNav = () => {
        navigate('/add-clientref')
    }

    const handleEditClientReferal = (item) => {
        if (Profile?.profile?.role === 'admin' || Profile?.profile?.role === 'coordinator') {
            // navigate(`/admin-clientref/${item?.referralId}`)
            navigate(`/view-client-references/${item?.referralId}` , {
                state:{ clientName:item?.clientName  , referralId:item?.referralId , status:item?.status}
            })                        

        } else {
            // navigate(`/edit-clientref`, { state: { refId: item?.referralId } })
            navigate(`/view-client-references/${item?.referralId}` , {
                state:{ clientName:item?.clientName  , referralId:item?.referralId}
            })                        

        }
    }

    const filteredTableDatas = clientRefTableDatas?.filter((item) => {
        return (
            (item?.clientName?.toLowerCase()?.includes(searchKeyword?.toLowerCase()))
        )
    })

    return (
        <Box className='container'>
            <Grid2 item sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography className="title">Client References</Typography>

                <div style={{ display: 'flex', gap: '20px' }}>
                    <Grid2 item>
                        <TextField
                            value={searchKeyword}
                            onChange={handleSearchKeywordChange}
                            className="textfields"
                            placeholder="Search"
                            slotProps={{
                                input: {
                                    startAdornment: <SearchIconLg style={{ paddingRight: '5px' }} />
                                }
                            }}
                        />
                    </Grid2>
                    <MUIButton startIcon={<AddIcon />} title='Add Referral' onClick={handleAddClientRefNav} sx={{ backgroundColor: '#7F56D9', width: '135px' }} />
                </div>
            </Grid2>

            <Grid2 container sx={{ marginTop: "15px" }}>
                <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={100} sx={{ padding: '10px' }}>
                                    <Box sx={{ width: '20%' }}>
                                        <Dropdown
                                            sx={{ width: '90%' }}
                                            placeholder='Select Status'
                                            value={selectedStatus || ""}
                                            options={clientReferalDropDown?.response?.type || []}
                                            onChange={handleStatusChange}
                                            valueKey='name'
                                            labelKey='name'
                                        />
                                    </Box>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="tableHeadersCell">Id</TableCell>
                                <TableCell className="tableHeadersCell">Name</TableCell>
                                <TableCell className="tableHeadersCell">Address</TableCell>
                                <TableCell className="tableHeadersCell">Email/Phone</TableCell>
                                <TableCell className="tableHeadersCell">Alternate Email/<br />Alternate Mobile</TableCell>
                                <TableCell className="tableHeadersCell">Contact Person</TableCell>
                                <TableCell className="tableHeadersCell">Status</TableCell>
                            </TableRow>
                        </TableHead>

                        {!showTableLoader ? (
                            filteredTableDatas?.length > 0 ? (
                                <TableBody>
                                    {filteredTableDatas?.map((item, index) => {
                                        const clientFirstLetter = item?.clientName
                                        const letter = clientFirstLetter?.charAt(0)?.toUpperCase()

                                        const contactPersonfirstLetter = item?.clientContact
                                        const contactPerson = contactPersonfirstLetter?.charAt(0)?.toUpperCase()

                                        const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                        const backgroundColor = colors[index % colors?.length]
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                    '&:hover': { backgroundColor: '#f1f1f1' },
                                                }}
                                                onClick={() => handleEditClientReferal(item)}
                                            >
                                                <TableCell className="tableBodyCell"  sx={{ color: '#53389E', cursor: 'pointer', fontWeight: 600, width: '6%' }}>{item?.referralId}</TableCell>
                                                <TableCell className="tableBodyCell" sx={{ display: 'flex', alignItems: 'center', gap: '7px', color: '#535862' }}>
                                                    <Avatar
                                                        sx={{ backgroundColor: backgroundColor, width: 30, height: 30, fontSize: '14px' }}
                                                    >
                                                        {letter}
                                                    </Avatar>
                                                    {item?.clientName}
                                                </TableCell>
                                                <TableCell className="tableBodyCell" sx={{ color: '#181D27' }}>{item?.address1}, {item?.city}, {item?.pincode}, {item?.state}, {item?.country}</TableCell>
                                                <TableCell className="tableBodyCell" sx={{ color: '#181D27' }}>{item?.email} / {item?.phone}</TableCell>
                                                <TableCell className="tableBodyCell" sx={{ color: '#181D27' }}>{item?.alternateEmail ? item?.alternateEmail : "NA"} / {item?.alternateMobile ? item?.alternateMobile : "NA"}</TableCell>
                                                <TableCell className="tableBodyCell" sx={{ display: 'flex', alignItems: 'center', gap: '7px', color: '#181D27' }}>
                                                    <Avatar
                                                        sx={{ backgroundColor: backgroundColor, width: 30, height: 30, fontSize: '14px' }}
                                                    >
                                                        {contactPerson}
                                                    </Avatar>
                                                    {item?.clientContact}
                                                </TableCell>
                                                <TableCell className="tableBodyCell">
                                                    <span className={`status-badge ${item?.status?.toLowerCase()}`}>
                                                        {item?.status}
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}

                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={8}>
                                    <Box className='tableloader'>
                                        <TableLoader />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                        {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <MUICancelButton
                                            title='Previous'
                                            disabled={page === 1}
                                            startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handlePageChange(null, page - 1)}
                                            sx={{ height: '36px' }}
                                        />

                                        <Pagination
                                            page={page}
                                            onChange={handlePageChange}
                                            count={Math.ceil(totalDataCount / rowsPerPage)}
                                            shape="rounded"
                                            boundaryCount={1}
                                            siblingCount={1}
                                            hideNextButton
                                            hidePrevButton
                                        />

                                        <MUICancelButton
                                            title='Next'
                                            onClick={() => handlePageChange(null, page + 1)}
                                            disabled={page === Math.ceil(totalDataCount / rowsPerPage)}
                                            startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalDataCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                            sx={{ height: '36px' }}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </Table>
                </Paper>

                {/* <Table>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                className="tablepagination"
                                page={page}
                                rowsPerPage={rowsPerPage}
                                onPageChange={handlePageChange}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPageOptions={[10, 20, 50]}
                                count={totalDataCount || 0}
                            />
                        </TableRow>
                    </TableFooter>
                </Table> */}
            </Grid2>
        </Box>
    )
}

export default ClientReferences